{
  "notifications": {
    "common": {
      "title": "Notifications",
      "markAllRead": "Mark all read",
      "viewAll": "View all notifications",
      "view": "View",
      "dismiss": "Dismiss",
      "unreadSummary_zero": "No unread notifications",
      "unreadSummary_one": "1 unread",
      "unreadSummary_other": "{{count}} unread"
    },
    "filters": {
      "status": {
        "all": "All",
        "unread": "Unread",
        "read": "Read"
      },
      "typeAll": "All"
    },
    "channels": {
      "inApp": "In-App",
      "email": "Email",
      "push": "Push",
      "sms": "SMS"
    },
    "types": {
      "info": "Info",
      "success": "Success",
      "warning": "Warning",
      "error": "Error",
      "mention": "Mention",
      "invite": "Invite",
      "payment": "Payment",
      "system": "System"
    },
    "empty": {
      "title": "No notifications",
      "description": "You're all caught up! Check back later."
    },
    "bell": {
      "openAria": "Open notifications",
      "countOverflowAria": "99 or more unread notifications",
      "countAria_one": "1 unread notification",
      "countAria_other": "{{count}} unread notifications"
    },
    "item": {
      "markReadAria": "Mark notification \"{{title}}\" as read",
      "notificationAria": "Notification \"{{title}}\""
    },
    "panel": {
      "closeAria": "Close notifications panel"
    },
    "preferences": {
      "pageTitle": "Notification Preferences",
      "pageDescription": "Manage how and when you receive notifications.",
      "formAria": "Notification preferences",
      "sections": {
        "channels": "Channels",
        "types": "Notification types",
        "quietHours": "Quiet hours"
      },
      "fields": {
        "start": "Start",
        "end": "End"
      },
      "toggleChannelAria": "Toggle {{channel}} notifications",
      "toggleTypeAria": "Toggle {{type}} notifications"
    },
    "time": {
      "justNow": "just now",
      "minutes_one": "1m ago",
      "minutes_other": "{{count}}m ago",
      "hours_one": "1h ago",
      "hours_other": "{{count}}h ago",
      "days_one": "1d ago",
      "days_other": "{{count}}d ago",
      "weeks_one": "1w ago",
      "weeks_other": "{{count}}w ago"
    },
    "dateBuckets": {
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "seo": {
      "notificationsTitle": "Notifications Inbox",
      "notificationsDescription": "Review unread activity, filter your inbox, and triage notifications across channels.",
      "preferencesTitle": "Notification Preferences",
      "preferencesDescription": "Tune channels, notification types, and quiet hours for your inbox experience.",
      "imageAlt": "Geenius Notifications preview"
    }
  }
}
